import { Component } from '@angular/core';
import { DataBoxComponent } from '@shared/components/data-box/data-box.component';
import { DataItem } from '@shared/models/data-item';

@Component({
  selector: 'app-flight-totals-info',
  standalone: true,
  imports: [
    DataBoxComponent
  ],
  templateUrl: './flight-totals-info.component.html',
  styleUrl: './flight-totals-info.component.scss'
})
export class FlightTotalsInfoComponent {

  titleTotals = "Total";
  titleYear = "Year";
  titleMonth = "Month"
  dataItemTotal: DataItem[] = [
    {
      label: "",
      value: `This is the total actual flight time for all dates and
      available records displayed in hours and minutes.`
    }
  ];

  dataItemYear: DataItem[] = [
    {
      label: "",
      value: `This is the total actual flight time for the selected calendar 
      year displayed in hours and minutes.`
    }
  ];
  
  dataItemMonth: DataItem[] = [
    {
      label: "",
      value: `This is the total flight time for the current month displayed 
      in hours and minutes.  Does not include deadheads or 
      cancelled flights.`
    }
  ];



}
